import { PublicApiClient } from '@/services/PublicApiClient.js'

export default {
  uploadDocument(farmerId, formData) {
    return PublicApiClient.postForm(
      `farmer-documents/${farmerId}/upload-document`,
      formData
    )
      .then((response) => {
        return response
      })
      .catch((err) => {
        throw err
      })
  }
}
